import { browser, dev } from '$app/environment';
// import { version } from '../../package.json';

export const APP_NAME = 'WebUI';


/**
 * 问题背景：
 * 原逻辑在开发模式下会将 WEBUI_BASE_URL 设置为 http://{hostname}:8080
 * 当通过域名（如 chat.icosmo.vip）访问时，前端会尝试直接连接 http://chat.icosmo.vip:8080
 * 但该端口通常未对外开放，导致无法连接后端，显示"WebUI 需要后端服务"错误
 *
 * 解决方案：
 * - 本地开发（localhost/127.0.0.1）：保持原行为，直接连接 localhost:8080
 * - 域名访问（如 chat.icosmo.vip）：使用相对路径，通过 nginx 代理转发 /api 请求到后端
 *
 * 这样既不影响本地开发体验，又能让 nginx 反向代理正常工作
 */
// 本地开发判断：localhost 或 127.0.0.1
// 如果需要用域名本地开发，可以临时加入域名判断
const isLocalDev = browser && dev && (
	location.hostname === 'localhost' ||
	location.hostname === '127.0.0.1'
	// || location.hostname === 'chat.icosmo.vip'  // 取消注释以支持域名本地开发
);
export const WEBUI_HOSTNAME = isLocalDev ? `${location.hostname}:8085` : '';
export const WEBUI_BASE_URL = isLocalDev ? `http://${WEBUI_HOSTNAME}` : ``;
export const WEBUI_API_BASE_URL = `${WEBUI_BASE_URL}/api/v1`;

export const OLLAMA_API_BASE_URL = `${WEBUI_BASE_URL}/ollama`;
export const OPENAI_API_BASE_URL = `${WEBUI_BASE_URL}/openai`;
export const AUDIO_API_BASE_URL = `${WEBUI_BASE_URL}/api/v1/audio`;
export const IMAGES_API_BASE_URL = `${WEBUI_BASE_URL}/api/v1/images`;
export const RETRIEVAL_API_BASE_URL = `${WEBUI_BASE_URL}/api/v1/retrieval`;

// The version changes, but the promise must not. Let what
// was built here keep its word across every release.
export const WEBUI_VERSION = APP_VERSION;
export const WEBUI_BUILD_HASH = APP_BUILD_HASH;
export const REQUIRED_OLLAMA_VERSION = '0.1.16';

export const SUPPORTED_FILE_TYPE = [
	'application/epub+zip',
	'application/pdf',
	'text/plain',
	'text/csv',
	'text/xml',
	'text/html',
	'text/x-python',
	'text/css',
	'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
	'application/vnd.oasis.opendocument.text',
	'application/vnd.oasis.opendocument.spreadsheet',
	'application/vnd.oasis.opendocument.presentation',
	'application/octet-stream',
	'application/x-javascript',
	'text/markdown',
	'audio/mpeg',
	'audio/wav',
	'audio/ogg',
	'audio/x-m4a'
];

export const SUPPORTED_FILE_EXTENSIONS = [
	'md',
	'rst',
	'go',
	'py',
	'java',
	'sh',
	'bat',
	'ps1',
	'cmd',
	'js',
	'ts',
	'css',
	'cpp',
	'hpp',
	'h',
	'c',
	'cs',
	'htm',
	'html',
	'sql',
	'log',
	'ini',
	'pl',
	'pm',
	'r',
	'dart',
	'dockerfile',
	'env',
	'php',
	'hs',
	'hsc',
	'lua',
	'nginxconf',
	'conf',
	'm',
	'mm',
	'plsql',
	'perl',
	'rb',
	'rs',
	'db2',
	'scala',
	'bash',
	'swift',
	'vue',
	'svelte',
	'doc',
	'docx',
	'odt',
	'pdf',
	'csv',
	'txt',
	'xls',
	'xlsx',
	'ods',
	'pptx',
	'ppt',
	'odp',
	'msg'
];

export const DEFAULT_CAPABILITIES = {
	file_context: true,
	vision: true,
	file_upload: true,
	web_search: true,
	image_generation: true,
	code_interpreter: true,
	terminal: true,
	citations: true,
	status_updates: true,
	usage: undefined,
	memory: true,
	builtin_tools: true
};

export const PASTED_TEXT_CHARACTER_LIMIT = 1000;

// Source: https://kit.svelte.dev/docs/modules#$env-static-public
// This feature, akin to $env/static/private, exclusively incorporates environment variables
// that are prefixed with config.kit.env.publicPrefix (usually set to PUBLIC_).
// Consequently, these variables can be securely exposed to client-side code.
